import { Box, FormControl, FormLabel, Input, Select, Stack } from "@chakra-ui/react";
import { IKonnyuRiport, IKonnyuRiportParam, IKonnyuRiportRow } from "@coimbra-its/api.konyvelo";
import { CellProps, formatDate, formatDateForInput, formatMoney, IWSysHub, useWSysHub, useWSysLayoutContext, useWSysMainTable, useWSysPage, useWSysPath, WSysHeaderButton, WSysPage, WSysTable, WSysVert } from "@coimbra-its/websys-ux-core";
import { useEffect, useState } from "react";
import { APPICONS } from "../../Icons";
import { useKonyveloApi } from "../../store/konyvelo.api";
import { KonnyuOptionsSelect } from "./KonnyuOptionsSelect";





export function KonnyuRiport({ riportRow }: { riportRow: IKonnyuRiportRow }) {



	//const hub = useWSysHub();
	const [isRun, setIsRun] = useState(0);
	const [paramValues, setParamValues] = useState<any>({});

	const api = useKonyveloApi();
	const [riportRes, hub] = api.konnyuReportParamsGet.useData({ id: riportRow.ID });
	const riport = riportRes?.report;

	const path = useWSysPath();
	const [q] = path.useParam('q');
	const [paginate, setPaginate] = useState(true);


	useEffect(() => {
		if (!riport)
			return;
		const newVal = {} as any;
		console.log(riport.PARAMS);
		riport.PARAMS.forEach(param => {
			//console.log(param.DEFAULT, formatDateForInput())
			if (param.TIPUS === 'D' && !isNaN(new Date(param.DEFAULT) as any))
				newVal[param.KEY] = formatDateForInput(new Date(param.DEFAULT));
			else
				newVal[param.KEY] = param.DEFAULT
		});

		setParamValues(newVal);
		setIsRun(0);
		hub.reset();
	}, [riport]);

	const setParamValue = (KEY: string, value: string) => {
		setIsRun(0);
		setParamValues({
			...paramValues,
			[KEY]: value
		});
	}

	const run = () => {
		setIsRun(riportRow.ID);
	}

	const { isMobileFull, widthCols } = useWSysLayoutContext();
	const page = useWSysPage({ title: riportRow.RIPORTNEV, maxCols: 6, variant: 'main' });

	const filteredOptions = (PARAM_KEY: string) => {
		return (search: string) => {
			const options = riport?.PARAMS.find(p => p.KEY === PARAM_KEY)?.OPTION_LIST || [];
			return options.filter(row => row.NEV.toLowerCase().split('|').slice(1).join().trim().startsWith(search.toLowerCase()) 
				|| row.KOD.toLowerCase().startsWith(search.toLowerCase()));
		}
	}


	const paramValueOption = (PARAM_KEY: string) => {
		const options = riport?.PARAMS.find(p => p.KEY === PARAM_KEY)?.OPTION_LIST || [];
		const selected = options.find(row => row.KOD === paramValues[PARAM_KEY]);
		return selected || null;
	}

	const optionWidth = (PARAM : IKonnyuRiportParam) => {
		if (PARAM.TIPUS === 'OPTIONS_SELECT' || PARAM.TIPUS === 'OPTIONS_AUTOCOMPLETE') 
			return '25em';
		return '9em';
	}

	//const setParamValueOption = (PARAM_KEY: string, option: { KOD: string, NEV: string } | null) => {


	return <WSysPage page={page} hubs={[hub]}

		tools={
			<Box display='flex' gap={2} alignItems='center'>
				{/*
				<WSysSearch name='q' />
				<WSysTableSettings orderBy={tableProps.forTable.orderBy} orderByChanged={tableProps.forTable.orderByChanged} cells={CELLS} reset={{ orderBy: '', title: 'Alaphelyzet (ID desc)' }} />
				wc:{widthCols}
				pag:<Switch size='sm' isChecked={paginate} onChange={e => setPaginate(e.target.checked)} name="pag"/>
				*/}
				<WSysHeaderButton icon={<APPICONS.Chart />} colorScheme="primary" onClick={() => run()}>Indít</WSysHeaderButton>
			</Box>

		}

	>
		<WSysVert mode="static" bg='var(--chakra-colors-primary-100)'>
			<Stack px={2} pb={1} flexDir={isMobileFull ? 'column' : 'row'} alignItems={isMobileFull ? 'flex-start' : 'flex-end'} border='red'  gap={4} flexWrap='wrap'>
				{(riport?.PARAMS || []).map((param, pix) => <FormControl key={pix} maxW={optionWidth(param)} display='flex' flexDir='column' alignItems='flex-start' justifyContent='flex-end'>
					<FormLabel>{param.NEV}</FormLabel>
					{param.TIPUS === 'D' && <Input type='date' value={paramValues[param.KEY]} onChange={e => setParamValue(param.KEY, e.target.value)} bg='#fff8' />}
					{['D', 'OPTIONS_SELECT', 'OPTIONS_AUTOCOMPLETE'].indexOf(param.TIPUS) === -1 && <Input value={paramValues[param.KEY]}  onChange={e => setParamValue(param.KEY, e.target.value)} bg='#fff8' />}
					{param.TIPUS === 'OPTIONS_SELECT' && <Select onChange={e => setParamValue(param.KEY, e.target.value)} value={paramValues[param.KEY]} bg='#fff8'>
						{param.OPTION_LIST?.map((opt, oix) => <option key={oix} value={opt.KOD}>{opt.NEV}</option>)}
					</Select>}
					{param.TIPUS === 'OPTIONS_AUTOCOMPLETE' && <><KonnyuOptionsSelect
						options={filteredOptions(param.KEY)}
						//options={proba}
						showId={false}
						value={paramValueOption(param.KEY)}
						onOptionChange={e => setParamValue(param.KEY, e?.KOD || '')} />
						</>}
				</FormControl>)}
			</Stack>
		</WSysVert>
		<WSysVert mode="rest">
			{!!riport && isRun === riport.ID && <Results hub={hub} params={paramValues} riport={riport} paginate={paginate} />}
		</WSysVert>
	</WSysPage>
}


interface resultProps {
	riport: IKonnyuRiport;
	params: any;
	hub: IWSysHub;
	paginate: boolean;
}

function Results({ riport, params, hub, paginate }: resultProps) {

	const path = useWSysPath();
	const tableProps = useWSysMainTable(path, []);
	const api = useKonyveloApi();
	const [result] = api.konnyuReportRunGet.useData({ id: riport.ID, params: JSON.stringify(params), ...tableProps.forPath, paginate }, { hub });
	const data = result?.result?.items || [];



	const [CELLS, setCELLS] = useState<CellProps<any>[]>([]);

	useEffect(() => {
		const newCELLS: typeof CELLS = [];
		if (data.length <= 0)
			return;
		const firstRow = data[0];
		let ix = 0;
		Object.keys(firstRow).forEach(key => {
			const title = riport.FIELDS[ix] || key

			const firstValue = firstRow[key];
			let isString = false;
			const field = riport.FIELDS[ix];
			if (field) {
				if (field.toUpperCase().indexOf('PARTNER') >= 0)
					isString = true;
			}
			if (typeof firstValue === 'number' && !isString) {
				newCELLS.push({
					title, charWidth: 12,
					elem: row => formatMoney(row[key] || 0, 'HUF'),
					align: 'right',
				});
			} else if ((''+firstRow[key]).length>=8 && !isNaN(new Date(firstRow[key]) as any) && !isString) {
				newCELLS.push({
					title, charWidth: 12,
					elem: row => formatDate(row[key]),
				});
			} else {
				newCELLS.push({
					title, charWidth: 22,
					elem: row => row[key],
				});
			}
			ix++;
		});
		setCELLS(newCELLS);

	}, [riport, data]);

	const { isMobileFull, widthCols } = useWSysLayoutContext();

	return <WSysTable
		rows={data}
		cells={CELLS}
		mode={2}
		noFixedColWidth={true}
		tableInfo={result?.result?.info}
		noHead={isMobileFull}
		{...tableProps.forTable}
	/>
}